import React from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

export default class Modal extends React.Component {
  constructor(props) {
    super(props)

    this.config = {
      types : [],
      modifiers : [ 
        {
          title: 'lg',
          isDefault: true
        },
        'sm'
      ],
    }

  }

  render() {
    let { data, isOpen, onCloseClick, ...rest } = this.props
    data = data || {}
    onCloseClick = onCloseClick || data.onCloseClick;
    isOpen = isOpen || data.isOpen
    const props = clearProps(this.props)
    return <div {...rest} className={resolveProps(this.props, this.config, 'Modal') + (isOpen ? ' mdn-isOpen' : '') }>
      <div className="mdn-Modal-content">
        <div className="mdn-Modal-header">
          {data.header}
          <button {...data.buttonProps} onClick={onCloseClick} className="mdn-Button-header-close mdn-Button mdn-Button--icon mdn-Button--secondary">
            <i className="mdn-Icon-fechar mdn-Icon--md"></i>
          </button>
        </div>
        <div className="mdn-Divider mdn-Divider--primary"></div>
        <div className="mdn-Modal-body">
          {data.content}
        </div>
        { data.footer ? <div className="mdn-Modal-footer">
          <div className="mdn-Modal-footer-start">
            {data.footer.content}
          </div>
          <div className="mdn-Modal-footer-end">
            {data.footer.action}
          </div>
        </div> : '' }
      </div>
    </div>
  }
}

Modal.propTypes = {
  children : PropTypes.string,

}